import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/lock.svg'
import _imports_1 from '@/assets/images/download.svg'


const _hoisted_1 = { class: "installation-guide container" }
const _hoisted_2 = { class: "breadcrumb-password-view py-3 row" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-dismissible alert-success",
  role: "alert"
}
const _hoisted_4 = { class: "alert__icon" }
const _hoisted_5 = {
  class: "btn-close",
  type: "button",
  "data-bs-dismiss": "alert",
  "aria-label": "Fechar"
}
const _hoisted_6 = { class: "row justify-content-betwen mt-5" }
const _hoisted_7 = { class: "col-lg-6 col-12 card card-info ms-2" }
const _hoisted_8 = { class: "btn btn-primary gap-2 mx-auto btn-sm px-2 pb-2 d-flex align-items-center" }
const _hoisted_9 = { class: "col-lg-6 col-12 card card-info ms-2" }
const _hoisted_10 = {
  class: "accordion",
  id: "Accordion2"
}
const _hoisted_11 = { class: "accordion-item" }
const _hoisted_12 = {
  class: "accordion-collapse collapse",
  id: "AccordionWhereFindCSR",
  "aria-labelledby": "AccordionFindCSR",
  "data-bs-parent": "#Accordion2"
}
const _hoisted_13 = { class: "accordion-body" }
const _hoisted_14 = { class: "m-0 text-start fs-6" }
const _hoisted_15 = {
  class: "accordion",
  id: "Accordion3"
}
const _hoisted_16 = { class: "accordion-item" }
const _hoisted_17 = {
  class: "accordion-collapse collapse",
  id: "AccordionWHatToDo",
  "aria-labelledby": "AccordionDontHaveCSR",
  "data-bs-parent": "#Accordion3"
}
const _hoisted_18 = { class: "accordion-body" }
const _hoisted_19 = { class: "m-0 text-start fs-6" }
const _hoisted_20 = ["href"]
const _hoisted_21 = {
  id: "modal-are-you-shure-button",
  "data-bs-target": "#modal-are-you-shure",
  "data-bs-toggle": "modal"
}
const _hoisted_22 = {
  id: "modal-only-desktop-issuer-button",
  "data-bs-target": "#modal-only-desktop",
  "data-bs-toggle": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Contact = _resolveComponent("Contact")!
  const _component_ModalAreYouShure = _resolveComponent("ModalAreYouShure")!
  const _component_ModalDownloadInstruction = _resolveComponent("ModalDownloadInstruction")!
  const _component_ModalOnlyUseOnDesktop = _resolveComponent("ModalOnlyUseOnDesktop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Breadcrumb, { "path-list": _ctx.pathlist }, null, 8, ["path-list"])
    ]),
    (_ctx.getSolicitation.cdSolicitacao)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Icon, { name: "shield" })
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "alert__content" }, [
            _createElementVNode("div", { class: "text" }, "Parabéns! Sua solicitação foi aprovada com sucesso! Verifique seu e-mail.")
          ], -1)),
          _createElementVNode("button", _hoisted_5, [
            _createVNode(_component_Icon, {
              class: "mt-2",
              name: "xmark"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"title-installation-guide text-start mt-4\" data-v-6fbcc572><h2 class=\"fs-1\" data-v-6fbcc572>Guia de instalação do Certificado Digital Financeiro e SSL</h2></div><div class=\"title-info-installation-guide text-start mt-3\" data-v-6fbcc572><h5 data-v-6fbcc572>Escolha abaixo como deseja instalar seu Certificado</h5></div><div class=\"title-info-installation-guide text-start mt-1\" data-v-6fbcc572><div class=\"text\" data-v-6fbcc572>Caso não deseje instalar seu Certificado agora, você poderá voltar aqui em outro momento.</div></div>", 3)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"img-box\" data-v-6fbcc572><img src=\"" + _imports_0 + "\" alt=\"Desenho de um Cadeado\" data-v-6fbcc572></div><div class=\"text-card\" data-v-6fbcc572><div class=\"text\" data-v-6fbcc572>Tem CSR próprio?</div><div class=\"text\" data-v-6fbcc572>Então esta opção é pra você!</div></div>", 2)),
        _createVNode(_component_router_link, { to: { name: "LoginSSl" } }, {
          default: _withCtx(() => [
            _createElementVNode("button", _hoisted_8, [
              _createVNode(_component_Icon, { name: "lock" }),
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "pt-1" }, "Tenho CSR próprio", -1))
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"img-box\" data-v-6fbcc572><img src=\"" + _imports_1 + "\" alt=\"Desenho de uma seta para Download do emissor\" data-v-6fbcc572></div><div class=\"text-card\" data-v-6fbcc572><div class=\"text\" data-v-6fbcc572>Não tem CSR próprio?</div><div class=\"text\" data-v-6fbcc572>Faça o download do nosso emissor.</div></div>", 2)),
        _createElementVNode("button", {
          class: "btn btn-primary gap-2 mx-auto btn-sm px-2 pb-2 d-flex align-items-center",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.issuerButtonClick && _ctx.issuerButtonClick(...args)))
        }, [
          _createVNode(_component_Icon, { name: "download" }),
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "pt-1" }, "Fazer download do emissor", -1))
        ])
      ])
    ]),
    _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"accordion\" id=\"Accordion1\" data-v-6fbcc572><div class=\"accordion-item\" data-v-6fbcc572><div class=\"accordion-header\" id=\"AccordionQuestionCSR\" data-v-6fbcc572><div class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#AccordionAnswerCSR\" aria-controls=\"AccordionAnswerCSR\" data-v-6fbcc572>O que é CSR?</div></div><div class=\"accordion-collapse collapse\" id=\"AccordionAnswerCSR\" aria-labelledby=\"AccordionQuestionCSR\" data-bs-parent=\"#Accordion1\" data-v-6fbcc572><div class=\"accordion-body\" data-v-6fbcc572><p class=\"m-0 text-start fs-6\" data-v-6fbcc572><strong data-v-6fbcc572>CSR</strong>, cuja sigla significa<strong data-v-6fbcc572>Certificate Signing Request</strong>, é um arquivo de texto, gerado no mesmo servidor em que você planeja instalar o certificado, a CSR contém informações (por exemplo, nome comum, empresa, país) que a Autoridade Certificadora (AC) usará para criar seu certificado. Ela também contém a chave pública que será incluída em seu certificado e é assinada com a chave privada correspondente.</p></div></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _cache[9] || (_cache[9] = _createElementVNode("div", {
          class: "accordion-header",
          id: "AccordionFindCSR"
        }, [
          _createElementVNode("div", {
            class: "accordion-button collapsed",
            type: "button",
            "data-bs-toggle": "collapse",
            "data-bs-target": "#AccordionWhereFindCSR",
            "aria-controls": "AccordionWhereFindCSR"
          }, "Onde encontro o código CSR?")
        ], -1)),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, [
              _cache[8] || (_cache[8] = _createTextVNode("A geração da CSR dependerá da plataforma que você estiver usando. Através do link a seguir, damos instruções de como fazer para gerar a CSR.")),
              _createVNode(_component_router_link, {
                class: "link",
                to: { name: "generateCSRResquest" }
              }, {
                default: _withCtx(() => [
                  _cache[7] || (_cache[7] = _createElementVNode("span", null, "Instruções para gerar CSR", -1)),
                  _createVNode(_component_Icon, {
                    class: "mx-2 icon",
                    name: "up-right-from-square"
                  })
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _cache[12] || (_cache[12] = _createElementVNode("div", {
          class: "accordion-header",
          id: "AccordionDontHaveCSR"
        }, [
          _createElementVNode("div", {
            class: "accordion-button collapsed",
            type: "button",
            "data-bs-toggle": "collapse",
            "data-bs-target": "#AccordionWHatToDo",
            "aria-controls": "AccordionWHatToDo"
          }, "Não tenho o código CSR neste momento, o que fazer?")
        ], -1)),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", _hoisted_19, [
              _cache[11] || (_cache[11] = _createTextVNode("Caso você não tenha a CSR para emissão do seu Certificado Digital SSL, você poderá utilizar nosso emissor. Basta fazer o download e executá-lo em seu computador. ")),
              _createElementVNode("a", {
                class: "link",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.issuerLinkClick && _ctx.issuerLinkClick(...args))),
                type: "button"
              }, [
                _cache[10] || (_cache[10] = _createElementVNode("span", null, "Fazer download do emissor", -1)),
                _createVNode(_component_Icon, {
                  class: "mx-2 icon",
                  name: "download"
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("a", {
      id: "dowload-link",
      href: _ctx.issuerUrl
    }, null, 8, _hoisted_20), [
      [_vShow, false]
    ]),
    _createVNode(_component_Contact),
    _createVNode(_component_ModalAreYouShure),
    _withDirectives(_createElementVNode("button", _hoisted_21, null, 512), [
      [_vShow, false]
    ]),
    _createVNode(_component_ModalDownloadInstruction),
    _createVNode(_component_ModalOnlyUseOnDesktop, null, {
      message: _withCtx(() => _cache[13] || (_cache[13] = [
        _createElementVNode("h3", null, [
          _createTextVNode("A instalação de um Certificado Digital através do emissor, deve ser feita em um "),
          _createElementVNode("strong", null, "computador ou notebook.")
        ], -1)
      ])),
      _: 1
    }),
    _withDirectives(_createElementVNode("button", _hoisted_22, null, 512), [
      [_vShow, false]
    ])
  ]))
}